<template>
  <div class="tabs">
    <template v-if="isJingJiang">
      <!-- 散客 -->
      <div class="tab tab2"
           @click="showPage(1)"
           :class="{active:pageIndex==1}"><span>{{$t('book_active1')}}</span></div>
      <!-- 协议公司 -->
      <div class="tab tab2"
           @click="showPage(3)"
           :class="{active:pageIndex==3}"><span>{{$t('book_active3')}}</span></div>
      <!-- 旅行社 -->
      <div class="tab tab2"
           @click="showPage(5)"
           :class="{active:pageIndex==5}"><span>{{$t('book_active5')}}</span></div>
    </template>
    <template v-else>
      <!-- 散客 -->
      <div class="tab"
           @click="showPage(1)"
           :class="{active:pageIndex==1}"><span>{{$t('book_active1')}}</span></div>
      <!-- 会员 -->
      <div class="tab"
           @click="showPage(2)"
           :class="{active:pageIndex==2}"><span>{{$t('book_active2')}}</span></div>
      <!-- 协议公司 -->
      <div class="tab"
           @click="showPage(3)"
           :class="{active:pageIndex==3}"><span>{{$t('book_active3')}}</span></div>
      <!-- 订房中心 -->
      <div class="tab"
           @click="showPage(4)"
           :class="{active:pageIndex==4}"><span>{{$t('book_active4')}}</span></div>
      <!-- 旅行社 -->
      <div class="tab"
           @click="showPage(5)"
           :class="{active:pageIndex==5}"><span>{{$t('book_active5')}}</span></div>
    </template>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isJingJiang: localStorage.getItem('isJingJiang') == 'yes',
      };
    },
    props: {
      pageIndex: {
        default: ''
      }
    },
    mounted() {

    },
    methods: {
      showPage(index) {
        this.$emit('showPage', index)
      }
    },
  };
</script>

<style lang="less">
  .bookpage {
    background: #fff;

    .tabs {
      width: 100%;
      height: 1.1493rem;
      text-align: center;
      box-sizing: border-box;
      margin-bottom: 1px;
      position: absolute;
      top: 1.04rem;
      z-index: 1;
      background: #f6f8f9;

      .tab {
        width: 20%;
        float: left;
        line-height: 1rem;
        height: 1rem;
        box-sizing: border-box;
        background: #fff;
        font-size: 0.33333333rem;

        &.tab2 {
          width: 33%;
        }

        span {
          line-height: 1rem;
          height: 1rem;
          display: inline-block;
        }

        &.active {
          border-bottom: 0.08rem solid #f69c2e;
        }

        &:nth-last-of-type(1).active {
          border-right: 0;
        }

        &:nth-of-type(1).active {
          border-left: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// bookTab.vue?b6aa6358